import Cookies from "js-cookie";

/**
 * Save user consent
 */
export const saveConsent = (consent) => {
  Cookies.set("cookie_consent", JSON.stringify(consent), {
    expires: 365, // 1 year
  });
};

/**
 * Read user consent
 */
export const getConsent = () => {
  const consent = Cookies.get("cookie_consent");
  return consent ? JSON.parse(consent) : null;
};
